import { render, staticRenderFns } from "./ArchivesWaterShow.vue?vue&type=template&id=61c50bc2&"
import script from "./ArchivesWaterShow.vue?vue&type=script&lang=js&"
export * from "./ArchivesWaterShow.vue?vue&type=script&lang=js&"
import style0 from "./ArchivesWaterShow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports